import { createApp } from "vue";
import App from "./App.vue";
import "./assets/main.scss";
import router from "./router/index";
import imgFallback from "./directives/v-img-fallback";
import { VueQueryPlugin } from "@tanstack/vue-query";
//@ts-ignore
import vSelect from "vue-select";

const app = createApp(App);

app.use(router).use(VueQueryPlugin);
app.directive("img-fallback", imgFallback);
app.mount("#app");

app.component("v-select", vSelect);
